<adapt-context-sidebar-implementation-kit [articleId]="ImplementationKitArticle.ValuePurposeVision"
                                          context="page"></adapt-context-sidebar-implementation-kit>

<div adaptToolbarContent
     adaptBlockingButtonGroup>
    @if (canEditGuidingPhilosophy$ | async) {
        <button adaptButtonIcon="edit"
                [adaptBlockingClick]="editGuidingPhilosophy"
                data-test="edit-guiding-philosophy-button">Edit purpose &amp; vision</button>
    }
</div>

@if (guidingPhilosophyHasData) {
    <div class="row">
        <div class="col-xl-6">
            <div class="card">
                <div class="card-header">
                    <h2 class="card-title">Purpose &amp; vision</h2>
                </div>
                <div class="card-body">
                    <adapt-see-more class="avoid-page-break-inside">
                        <h3>Purpose</h3>
                        @if (organisationPurpose?.content; as purpose) {
                            <p [froalaView]="purpose"
                               data-test="guiding-philosophy-purpose"></p>
                        } @else {
                            <p>No purpose has been defined.</p>
                        }
                    </adapt-see-more>
                    <adapt-see-more class="avoid-page-break-inside">
                        <h3>Vision</h3>
                        @if (guidingPhilosophy?.vision; as vision) {
                            <p [froalaView]="vision"
                               data-test="guiding-philosophy-vision"></p>
                        } @else {
                            <p>No vision has been defined.</p>
                        }
                    </adapt-see-more>
                </div>
            </div>
        </div>
        <div class="col-xl-6">
            <div *adaptIfFeatureActive="FeatureName.Bullseye; else bullseyeNotActive"></div>
            <ng-template #bullseyeNotActive>
                <div class="card">
                    <div class="card-header">
                        <h2 class="card-title">Bullseye</h2>
                    </div>
                    <div class="card-body">
                        @if (guidingPhilosophy?.bullseye; as bullseye) {
                            <p [froalaView]="bullseye"
                               data-test="guiding-philosophy-bullseye"></p>
                        } @else {
                            <p>No bullseye has been defined.</p>
                        }
                    </div>
                </div>
            </ng-template>
            @if (guidingPhilosophy?.context) {
                <div class="card">
                    <div class="card-header">
                        <h2 class="card-title">Founding story</h2>
                    </div>
                    <div class="card-body">
                        <adapt-see-more [maxHeight]="200">
                            <div [froalaView]="guidingPhilosophy?.context"
                                 data-test="guiding-philosophy-founding-story"></div>
                        </adapt-see-more>
                    </div>
                </div>
            }
        </div>
    </div>
} @else {
    <adapt-call-to-action [learnMoreUrl]="learnMoreUrl">
        <adapt-call-to-action-title>Purpose &amp; vision</adapt-call-to-action-title>
        <p>Having a clear purpose and well-defined vision helps keep everyone driving in the same direction.</p>
        <p>Your purpose answers the question of why this business exists. It should talk to your cause, your passion, what you care about.
        </p>
        <p>The point of having a vision is to create something bigger than yourself, something that people can believe in and rally behind.
            A picture of a future that provides meaning and direction.</p>
        @if (canEditGuidingPhilosophy$ | async) {
            <button adaptCallToActionButton
                    adaptButtonIcon="edit"
                    [adaptBlockingClick]="editGuidingPhilosophy">Edit purpose &amp; vision</button>
        }
    </adapt-call-to-action>
}

@if (lastUpdated; as updated) {
    <adapt-entity-timestamp class="text-muted"
                            [timestamp]="updated"
                            prefix="Last updated"></adapt-entity-timestamp>
}
